import { Group } from '@mantine/core'
import { faArrowUpRightFromSquare } from '@fortawesome/sharp-duotone-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Mc1CaseLink } from '../Common/Mc1CaseLink'

export interface ViewAllTasksLinkProps {
  // MC1 case id — task actions beyond hold/reminder happen in MC1 (MSD-687).
  // Per Fil, this is the same claim-page link as the claim-number header link, so it
  // shares that link's implementation rather than repeating it.
  caseId: number
}

export function ViewAllTasksLink({ caseId }: Readonly<ViewAllTasksLinkProps>) {
  return (
    <Mc1CaseLink caseId={caseId} tooltip="View all tasks in MC1">
      <Group gap={4} wrap="nowrap" component="span">
        View all Tasks
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="xs" />
      </Group>
    </Mc1CaseLink>
  )
}
